<template>
    <div class="swiper-pdf-container pdf-container">
        <div class="view-container">
            <div class="loading-container" v-show="loading[activeIndex || 0]">
                <Loading-item></Loading-item>
            </div>
            <swiper
                ref="mySwiper"
                class="pdf-wrapper"
                @slideChangeTransitionStart="slideChangeTransitionStart"
                @doubleTap="doulebleTap"
                @transitionStart="emitEnd"
                :options="swiperOptions"
            >
                <swiper-slide
                    class="pdf-page"
                    v-for="index of range"
                    :key="index"
                >
                    <pdf
                        :src="files"
                        :page="index"
                        :text="false"
                        :scaleRate="2"
                        :wrapperStyle="{ maxHeight: '90vh', overflowY: 'auto' }"
                        @loading="loaded(index)"
                    ></pdf>
                </swiper-slide>
                <div
                    class="myswiper-button-prev"
                    slot="button-prev"
                    v-show="activeIndex != 0"
                ></div>
                <div
                    class="myswiper-button-next"
                    slot="button-next"
                    v-show="activeIndex != total - 1"
                ></div>
            </swiper>
        </div>
        <div class="action-group">
            <img
                src="https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/cus_files/custouch/site/image/%E7%AE%AD%E5%A4%B4.png"
                class="button left"
                @click="slideTo(-1)"
            />
            <div class="center" v-if="total">
                &lt;{{ activeIndex + 1 }}/{{ total }}&gt;
            </div>
            <div class="center" v-else>
                Loading...
            </div>
            <img
                src="https://custouch-cloud.oss-cn-hangzhou.aliyuncs.com/cus_files/custouch/site/image/%E7%AE%AD%E5%A4%B4.png"
                class="button right"
                @click="slideTo(1)"
            />
        </div>
        <img-viewer
            ref="viewer"
            v-if="swiper.el"
            v-model="showPreview"
            :bolb="canvasBolb[swiper.activeIndex]"
        >
        </img-viewer>
    </div>
</template>
<script>
import pdf from './Pdfvuer'

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import LoadingItem from './LoadingItem'
// import style
import 'swiper/css/swiper.css'
import ImgViewer from './ImgViewer'
import Hammer from 'hammerjs'
export default {
    props: {
        maxPage: {
            type: Number,
            default: null
        },
        pdfUrl: {}
    },
    data() {
        return {
            showPreview: false,
            canvasBolb: {},
            loading: [true],
            files: {},
            page: 1,
            total: 0,
            range: 0,
            canvasGroup: {},
            reachLast: false,
            swiperOptions: {
                // effect: 'fade',
                // effect: 'cube',
                // effect: 'coverflow',
                // effect: 'flip',
                pagination: {
                    el: '.swiper-pagination'
                    // type: 'bullets',
                    //type: 'fraction',
                    // type: 'progressbar'
                    //type : 'custom',
                },
                navigation: {
                    nextEl: '.myswiper-button-next',
                    prevEl: '.myswiper-button-prev'
                }
            },
            swiper: {},
            finished: false
        }
    },
    components: {
        pdf,
        Swiper,
        SwiperSlide,
        LoadingItem,
        ImgViewer
    },
    mounted() {
        if (this.pdfUrl) {
            this.files = pdf.createLoadingTask({
                url: this.pdfUrl,
                cMapUrl:
                    'https://oss.cloud.custouch.com/static/cloud/font/cmaps/',
                cMapPacked: true
            })
            this.files
                .then(pdf => {
                    this.total = pdf.numPages
                    this.loading.length = this.total
                    this.loading.fill(true)
                    this._updateRange(Math.min(this.total, 3))
                    this.swiper = this.$refs.mySwiper.$swiper
                    this.$emit('load', { total: this.total })
                    this.detechPinch()
                })
                .catch(err => {
                    this.$emit('error', err.message)
                })
        }
    },
    computed: {
        activeIndex() {
            return this.swiper.activeIndex
        }
    },
    methods: {
        detechPinch() {
            const mc = new Hammer.Manager(
                document.querySelector('.swiper-wrapper')
            )
            mc.add(new Hammer.Pinch({ threshold: 0 }))
            mc.on('pinchmove', () => {
                this.doulebleTap()
            })
        },
        doulebleTap(e) {
            if (this.loading[this.activeIndex]) return
            this.genTargetBolb()
            this.showPreview = true
        },
        getReadyRange() {
            const index = this.loading.findIndex(_ => _)
            // return index + 5
            return this.activeIndex + 3
        },
        getLastIndex() {
            if (this.maxPage) {
                return Math.min(this.maxPage, this.total) - 1
            } else {
                return this.total - 1
            }
        },
        setStatus() {
            if (this.maxPage == null) return
            if (this.activeIndex >= this.getLastIndex()) {
                this.reachLast = true
            } else {
                this.reachLast = false
            }
        },
        slideChangeTransitionStart() {
            this.setStatus()
            if (this.finished) return
            let updateRange = this.getReadyRange()
            if (updateRange >= this.total) {
                updateRange = this.total
                this.finished = true
            }
            this._updateRange(updateRange)
        },
        _updateRange(range) {
            if (this.maxPage != null) {
                this.range = Math.min(this.maxPage, range)
            } else {
                this.range = range
            }
        },
        genTargetBolb() {
            const canvas = document.querySelector('.swiper-slide-active canvas')
            const target = this.canvasBolb[this.activeIndex]
            if (!target) {
                this.canvasBolb[this.activeIndex] = canvas.toDataURL(
                    'image/png'
                )
            }
        },
        emitEnd() {
            if (this.reachLast && this.maxPage === this.activeIndex + 1) {
                this.$emit('maxEnd')
            }
        },
        slideTo(index) {
            if (!this.swiper.slideTo) return
            const targetIndex = this.activeIndex + index
            if (targetIndex >= this.maxPage) {
                this.emitEnd()
            }
            this.swiper.slideTo(targetIndex, 500)
        },
        loaded(page) {
            this.$set(this.loading, page - 1, false)
        }
    }
}
</script>

<style scoped lang="less">
.myswiper-button-prev,
.myswiper-button-next {
    color: #fff;
    position: absolute;
    top: 50%;
    z-index: 10;
    display: inline-block;
    width: 15px;
    height: 15px;
    border-bottom: 2px solid #ccc;
    border-right: 2px solid #ccc;
    outline: none;
}
.myswiper-button-next {
    right: 0.5rem;
    transform: rotate(-45deg);
}
.myswiper-button-prev {
    left: 0.5rem;
    transform: rotate(135deg);
}
</style>
